import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/properties-payments-properties`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/properties-payments-properties/${id}?include=propertiesPayment,property,properties`,
      options
    )
    .then((response) => {
      let propertiesPayment = jsona.deserialize(response.data);
      delete propertiesPayment.links;
      return propertiesPayment;
    });
}

function add(propertiesPayment) {
  const payload = jsona.serialize({
    stuff: propertiesPayment,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/properties-payments-properties`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(propertiesPayment) {
  const payload = jsona.serialize({
    stuff: propertiesPayment,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/properties-payments-properties/${propertiesPayment.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/properties-payments-properties/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
